import { Button, ChevronStartIcon, Flex, Text } from "@fluentui/react-northstar";
import React, { useCallback } from "react";
import { useHistory } from "react-router";

import { useUserInfo } from "../../../_shared/actions/useUserInfo";
import { ResponseUsageMeter } from "../../../_shared/components/MeterBars/ResponseUsageMeter";
import { clientEventTracker } from "../../../_shared/utils/clientTelemetry";
import { getPageContext } from "../../../_shared/utils/teamsHelpers";
import { AuthoringFormHeaderOptions } from "./PollySurveyAuthoringForm";

export const AuthoringFormHeader: React.FC<AuthoringFormHeaderOptions> = props => {
  const { isEdit, templateId, trackingSource } = props;

  const context = getPageContext();
  const { user } = useUserInfo();
  const history = useHistory();
  const cancelAction = useCallback(() => {
    if (history.action !== "POP") {
      history.goBack();
    } else {
      history.replace("/msteams/content/start");
    }
  }, [history]);

  return (
    <div style={{ paddingTop: "10px", paddingBottom: "15px" }}>
      {context === "/msteams" && !isEdit && (
        <Flex vAlign="center">
          <Flex.Item grow>
            <div className="polly-authoring-page__back-button">
              <Button
                text
                content={
                  <Flex vAlign="center">
                    <ChevronStartIcon xSpacing="after" />
                    Back
                  </Flex>
                }
                onClick={() => {
                  clientEventTracker.track("polly authoring back clicked", user, {
                    templateId,
                    trackingSource,
                  });
                  cancelAction();
                }}
              />
            </div>
          </Flex.Item>
          <Flex.Item push>
            <ResponseUsageMeter />
          </Flex.Item>
        </Flex>
      )}

      {context === "/agile" && (
        <Text content="New Standup" size="large" align="center" weight="bold" color="brand" />
      )}
    </div>
  );
};
